import { render } from "./ConnectionRate.vue?vue&type=template&id=fa091954&scoped=true&ts=true&lang=pug"
import script from "./ConnectionRate.vue?vue&type=script&lang=ts"
export * from "./ConnectionRate.vue?vue&type=script&lang=ts"

import "./ConnectionRate.vue?vue&type=style&index=0&id=fa091954&scoped=true&lang=css"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa091954"]])

export default __exports__